export const GAMING_CAMPAIGN_TYPE = 'video-game-addiction'
export const GAMING_CAMPAIGN_NAME = 'Video Game Addiction'

